/* ============ cards & shoe ============
   Pure card logic. The shuffle is DETERMINISTIC: the same (settings, seed)
   always produces the same shoe — the foundation for replay validation. */

export const SUITS = ["♠", "♥", "♦", "♣"];
export const RANKS = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];
export const TEN = { "10": 1, J: 1, Q: 1, K: 1 };

/* mulberry32: small, fast, seedable PRNG. NOT cryptographic — it doesn't
   need to be; it needs to be reproducible. */
export function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/* random 32-bit seed; crypto-quality when available so seeds are unguessable */
export function makeSeed() {
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const buf = new Uint32Array(1);
    crypto.getRandomValues(buf);
    return buf[0];
  }
  return Math.floor(Math.random() * 2 ** 32);
}

/* Build and Fisher-Yates-shuffle a shoe. Card order is fully determined by
   (settings.decks, seed) — never call Math.random() in here. */
export function freshShoe(st, seed) {
  const shoe = [];
  let id = 0;
  for (let d = 0; d < st.decks; d++)
    for (const su of SUITS)
      for (const r of RANKS) shoe.push({ r, s: su, id: id++ });
  const rng = mulberry32(seed);
  for (let i = shoe.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [shoe[i], shoe[j]] = [shoe[j], shoe[i]];
  }
  return shoe;
}

/* hand value: { total, soft } with aces reduced as needed */
export function hv(cards) {
  let t = 0,
    aces = 0;
  for (const c of cards) {
    if (c.r === "A") {
      t += 11;
      aces++;
    } else if (TEN[c.r]) t += 10;
    else t += +c.r;
  }
  while (t > 21 && aces) {
    t -= 10;
    aces--;
  }
  return { total: t, soft: aces > 0 };
}

export const upVal = (c) => (c.r === "A" ? 11 : TEN[c.r] ? 10 : +c.r);
export const pairRank = (c) => (TEN[c.r] ? "10" : c.r);
export const isBJ = (cards) => cards.length === 2 && hv(cards).total === 21;
